export const ACCOUNT_RESET_MEDIA_TYPE = 'application/vnd.io.tunnr.api.account.reset.v1+json';

export interface AccountResetRequest {
  password: string;
}
